import { createFileRoute } from '@tanstack/react-router'
import EditionCostContainer from 'Edition/containers/EditionCostContainer'

import { Guard } from '../../../../-guard'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/general-costs')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <EditionCostContainer />
        </Guard>
    ),
})
